import { Button, Card, Tooltip, Typography } from 'antd';

import PermissionHide from 'v2/components/Shared/PermissionHide';
import { Mask } from 'v2/components/Shared/ValuesVisibility';
import { numberToBRL } from 'v2/helpers/money';

import { Icon } from '@eduzz/ui-antd-theme';

import type { Props } from './constants';
import { ThemeColors } from './constants';

function ValueCard({
  id,
  title,
  isLoading,
  value,
  valueTheme,
  hint,
  isCtaDisabled = false,
  ctaCopy,
  ctaButtonTooltip,
  isTooltipOpen = undefined,
  ctaCallback,
  ctaAccessControl = '',
  bottomExtra
}: Props) {
  const valueClass = valueTheme === ThemeColors.SUCCESS ? 'text-(--uizz-antd-color-success)' : '';

  const renderCtaButton = () => {
    const ctaButton = () => (
      <Button
        type='primary'
        size='small'
        className='h-7 text-sm'
        onClick={!isCtaDisabled ? ctaCallback : undefined}
        disabled={isCtaDisabled}
      >
        {ctaCopy}
      </Button>
    );

    if (ctaButtonTooltip) {
      return (
        <Tooltip open={isTooltipOpen} title={ctaButtonTooltip} placement='top'>
          <span>{ctaButton()}</span>
        </Tooltip>
      );
    }

    return ctaButton();
  };

  return (
    <Card id={id} className='h-full' classNames={{ body: 'flex h-full flex-col gap-3 p-4' }}>
      <div className='flex items-center justify-between gap-2'>
        <Typography.Text type='secondary'>{title}</Typography.Text>
        <Tooltip title={hint} placement='top'>
          <Icon.CircleHelp color='gray' size={16} />
        </Tooltip>
      </div>

      <div className='flex flex-wrap items-center justify-between gap-2'>
        <Typography.Text className={`text-lg font-bold ${valueClass}`}>
          <Mask>{!!isLoading || typeof value !== 'number' ? '-' : numberToBRL(value)}</Mask>
        </Typography.Text>

        {!!ctaCopy && !!ctaCallback && <PermissionHide action={ctaAccessControl}>{renderCtaButton()}</PermissionHide>}
      </div>

      {!!bottomExtra && <div>{bottomExtra}</div>}
    </Card>
  );
}

export default ValueCard;
